import { useQuery } from '@provision/graphql-client';
import { QueryVariables } from 'src/graphql/types';
import {
  GET_OPEN_SMS_SESSION_QUERY,
  type GetConversationSmsSessionQuery,
  getOpenSmsSessionQueryVariables,
} from 'src/pages/Conversations/Chat/SmsSession/sms-session.operations';

export function useOpenSmsSession(conversationId: string): {
  hasOpenSession: boolean;
  sessionId: string | null;
  channelId: string | null;
  openedAt: string | null;
  loading: boolean;
} {
  const { data, loading } = useQuery<GetConversationSmsSessionQuery, QueryVariables>(
    GET_OPEN_SMS_SESSION_QUERY,
    {
      variables: getOpenSmsSessionQueryVariables(conversationId),
      skip: !conversationId,
    },
  );

  const openRecord = data?.getConversationSmsSession?.records?.[0] ?? null;

  return {
    hasOpenSession: openRecord !== null,
    sessionId: openRecord?.conversationSmsSessionId ?? null,
    channelId: openRecord?.conversationChannelId ?? null,
    openedAt: openRecord?.openedAt ?? null,
    loading,
  };
}
